module.exports = __webpack_public_path__ + "img/66774182.66282627.png";